export const MARKER_CLICK = 'marker:click';
